import { css } from "lit";

/**
 * Focus ring box-shadow using `--sky-focus-ring-color` (falls back to active-primary).
 *
 * Theme-level `--sky-focus-ring` resolves nested `var()` on the theme host before
 * inheritance, so local color overrides do not retint an inherited ring. Redeclare
 * this formula on the same element that sets `--sky-focus-ring-color`.
 */
export const SKY_FOCUS_RING_SHADOW =
  "0 0 0 3px color-mix(in oklch, var(--sky-focus-ring-color, var(--sky-active-primary)) 42%, transparent)";

/** Redeclare `--sky-focus-ring` on `:host` so local `--sky-focus-ring-color` applies. */
export const skyFocusRingHostStyles = css`
  :host {
    --sky-focus-ring: 0 0 0 3px color-mix(
      in oklch,
      var(--sky-focus-ring-color, var(--sky-active-primary)) 42%,
      transparent
    );
  }
`;
